module.exports = __webpack_public_path__ + "img/home.fc4c7ab7.svg";